import { useState, useEffect } from 'react';
import { Flex, Stack, useToast } from '@chakra-ui/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { updateOrgProfile, updateOrgProfileReset } from '../../../organizations/actions/organizations-actions';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import { getAdminOrgProfile } from '../../actions/admin-user-actions';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckModalButtonBar from '../../../global/components/helper-components/components/LaunchdeckModalButtonBar';
import LaunchdeckFormTextAreaInput from '../../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';


function EditOrgInfoForm({ 
	orgProfile, 
	handleCloseModal, 
	// Redux
	manageAdminOrgProfileOutcome, 
	isMobileView, 
	// Actions
	getAdminOrgProfile,
	updateOrgProfile,
	updateOrgProfileReset,
 }) {

	const toast = useToast();

	const { orgName, orgId, orgDescription } = orgProfile || {}
	const [editingInProgress, setEditingInProgress] = useState(false);

	// Inputs
	const [orgNameDisplay, setOrgNameDisplay] = useState(orgName)
	const [orgDescriptionDisplay, setOrgDescriptionDisplay] = useState(orgDescription)


	// Input validation Errors
	const [showMissingorgNameError, setShowMissingorgNameError] = useState(false)

	// UX & State Management
	useEffect(() => {
		if (manageAdminOrgProfileOutcome) {
			const { updatedSuccessfully, errorMessage } = manageAdminOrgProfileOutcome || {};

			const closeModalAndReset = () => {
				setEditingInProgress(false)
				handleCloseModal()
				updateOrgProfileReset()
			}

			if (updatedSuccessfully === true) {
				getAdminOrgProfile()

				toast(
					triggerLaunchdeckToast({
						useCase: "show-success-state",
						// bannerText: "",
						label: "Your organization info has been updated",
						isMobileView
					})
				)

				closeModalAndReset()
			}

			if (updatedSuccessfully === false) {
				if (errorMessage) {

					toast(
						triggerLaunchdeckToast({
							useCase: "show-error-state",
							bannerText: "Error",
							label: errorMessage,
							isMobileView
						})
					)

					closeModalAndReset()
				}
			}
		}
	}, [manageAdminOrgProfileOutcome, handleCloseModal, toast]);

	// Component functionality
	const handleChange = (event) => {
		const value = event.target.value;
		const variableName = event.target.name;
		switch (variableName) {
			case ('orgName'): {
				setOrgNameDisplay(value)
				break;
			}
			case ('orgDescription'): {
				setOrgDescriptionDisplay(value)
				break;
			}
			default: {
				console.log('There is no variable with this name', variableName)
				break;
			}
		}
	}

	const handleSubmitEditProfile = () => {
		if (!orgNameDisplay) {
			setShowMissingorgNameError(true)
		} else if (orgNameDisplay) {
			setShowMissingorgNameError(false)
		}

		if (orgNameDisplay) {
			setEditingInProgress(true)

			let updateOrgUserProperties = {
				orgName: orgNameDisplay.trim(),
				orgDescription: orgDescriptionDisplay ? orgDescriptionDisplay.trim() : ""
			}

			updateOrgProfile(updateOrgUserProperties, orgId, 'edit-org-profile-info')
		}
	}


	return (
		<Flex align='center' w='100%' maxW={['inherit','35em']} direction='column' overflowY='auto' maxHeight='75vh' >
			<Stack w='100%' maxW={['inherit','35em']} px='2em' py='1em' gap='1.5em'>
					<LaunchdeckFormInput
						label='Organization Name'
						name={'orgName'}
						value={orgNameDisplay}
						onChange={handleChange}
						isRequired={true}

						errorLogic={showMissingorgNameError}
						errorMessage="Required"
					/>

					<LaunchdeckFormTextAreaInput
						label='About'
						name={"orgDescription"}
						onChange={handleChange}

						value={orgDescriptionDisplay}
						charLimit={250}
					/>
			</Stack>

		
				<LaunchdeckModalButtonBar
					fontSize='1em'
					handleCloseModal={handleCloseModal}
					loadingLogic={editingInProgress}
					ctaFunction={() => handleSubmitEditProfile()}
					ctaLabel='Save Changes'
					cancelLabel='Cancel'
				/>
		</Flex>

	);
}

function mapStateToProps(state) {
	return {
		manageAdminOrgProfileOutcome: state.manageAdminOrgProfileOutcome.results.data,
		isMobileView: state.mobileViewMode.isMobileView
	};
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAdminOrgProfile,
			updateOrgProfile,
			updateOrgProfileReset,
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditOrgInfoForm));